import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginationComponent implements OnInit, OnChanges {

    @Input() lastPage: number;
    @Input() activePage = 1;
    @Output() setPage = new EventEmitter();
    pages = [];

    constructor() {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.lastPage.currentValue) {
            this.pages = [...Array(this.lastPage)].map((e, i) => i + 1);
        }
    }

    clickPAge(p: number) {
        this.activePage = p;
        this.setPage.emit(p);
    }
}
